import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cup, tea, coffee, mug"} maskId="square-filled-radius-0-stroke-1-IconCup"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V6H21V13H17V21H3V3ZM17 12H20V7H17V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCup;
